import { render, staticRenderFns } from "./DocumentUploadItem.vue?vue&type=template&id=cdb9cfcc&scoped=true"
import script from "./DocumentUploadItem.vue?vue&type=script&lang=js"
export * from "./DocumentUploadItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb9cfcc",
  null
  
)

export default component.exports